<template>
    <PatientPayerInformation class="mb-2" />
    <AdmissionInformation />
</template>

<script src="./PayerInformation.ts"></script>
